import axios from '../../../utils/AxiosUtils';

import {
    GET_ALL_PAYMENT_PROVIDERS_SUCCESS,
    SAVE_TRANSACTION_ID,
    MOLLIE_RESPONSE_STATUS,
    AUTHIPAY_RESPONSE_STATUS,
    AUTHIPAY_DATA,
    CLICK_APPLE_GOOGLE_PAY,
    BAMBORA_DATA,
    CLEAR_BAMBORA_DATA,
    STRIPE_HOSTED_PAYMENT_DATA,
    CLEAR_STRIPE_HOSTED_PAYMENT_DATA,
    WORLDPAY_DATA,
    CLEAR_WORLDPAY_DATA,
    MONERIS_DATA,
    CLEAR_MONERIS_DATA,
    CLEAR_TBK_DATA,
    TBK_USER_DATA,
    RYFT_DATA,
    CLEAR_RYFT_DATA,
    CONFIRM_ENROLLMENT_ERR_MSG
} from '../../types';
import { placeOrder, errorProcessingPayment, sendEmailReport } from '../ShoppingCartActions';
import { changeAuthipayBackBtnFlag } from '../../StoreLocalStorageActions';
import { IN_STORE_ID } from '../../../utils/Constants';

export const getPaymentProvider = (restaurantId) => {
    return (dispatch, getState) => {

        const url = `/restaurant/${restaurantId}/payment-provider`;

        axios(getState).get(url)
            .then(res => getPaymentProviderSuccess(res, dispatch))
            .catch(err => console.log('err ', err));
    }
};

const getPaymentProviderSuccess = (res, dispatch) => {

    dispatch({ type: GET_ALL_PAYMENT_PROVIDERS_SUCCESS, payload: res.data });
};

export const dispatchTransactionId = (transactionId, providerId, providerData, timeOutInterval) => {
    return (dispatch, getState) => {

        let providerStatus = MOLLIE_RESPONSE_STATUS;
        let urlPath = 'payment/status';

        if (providerId === 4) {
            providerStatus = AUTHIPAY_RESPONSE_STATUS;
            urlPath = 'payment-status';
        }

        paymentStatusPoll(() => {
            const url = `/${urlPath}?paymentId=${transactionId}`;

            axios(getState).get(url)
                .then(res => {
                    dispatch({ type: providerStatus, payload: providerId === 4 ? res.data : res.data.status });
                })
                .catch(err => sendEmailReport(`${getState().selectedRestaurant.restaurantId}-paymentProvider-${providerId}`, err, 'statusPolling'));

        }, getState, 3000, dispatch, providerId, providerData, timeOutInterval);
        if (providerId === 3) {
            dispatch({ type: SAVE_TRANSACTION_ID, payload: transactionId });
        }
    }
};

const paymentStatusPoll = (fn, getState, interval, dispatch, providerId, providerData, timeOutInterval) => {
    let endCondition = getState().paymentProvider.molliePaymentStatus//Number(new Date()) + (timeout || 2000);
    if (providerId === 4) {
        endCondition = getState().paymentProvider.authipayPaymentStatus;
    }
    const intervalMins = timeOutInterval ? timeOutInterval : 60;
    const timedOutConditon = Number(new Date()) + (1000 * intervalMins * 1);
    interval = interval || 100;

    const checkCondition = function (resolve, reject) {
        endCondition = getState().paymentProvider.molliePaymentStatus;
        const conditionData = checkConditionsAccordingToProvider(providerId, getState, providerData);

        if (providerId === 4) {

            endCondition = getState().paymentProvider.authipayPaymentStatus ? getState().paymentProvider.authipayPaymentStatus.status : null;
        }
        // If the condition is met, we're done! 
        const result = fn();

        if (result) {
            // TODO this will always be undefined maybe there is a better way to do it - should research!!
            resolve(result);
        } else if (new Date() > timedOutConditon) {
            dispatch(errorProcessingPayment('timedOut', conditionData.errOrigin, providerId));
            if (providerId === 4) {
                dispatch(sendEmailReport(getState().selectedRestaurant.restaurantId, endCondition, `TIMEDOUT-paymentProvider-${providerId}`));
                dispatch(changeAuthipayBackBtnFlag(true));
            }
            return resolve();
        }
        // If the condition isn't met but the timeout hasn't elapsed, go again
        else if (endCondition === 'OPEN' || endCondition === 'PENDING' || endCondition === 'WAITING' || !endCondition) {

            setTimeout(checkCondition, interval, resolve, reject);
        } else if (endCondition === conditionData.successCondition) {
            if (providerId === 4) {
                dispatch(changeAuthipayBackBtnFlag(true));
            }
            let secondPlaceOrderParam = providerId === 4 ? providerData : { paymentId: conditionData.paymentId };
            dispatch(placeOrder(false, secondPlaceOrderParam));

            return resolve();
        } else if (endCondition === 'FAILED' || endCondition === 'CANCELED' || endCondition === 'EXPIRED' || endCondition === 'DECLINED'
            || endCondition === 'VALIDATION_FAILED' || endCondition === 'PROCESSING_FAILED') {

            if (providerId === 4) {
                dispatch(changeAuthipayBackBtnFlag(true));
            }
            let secondParam = providerId === 4 ? getState().paymentProvider.authipayPaymentStatus.reason : conditionData.errOrigin;
            dispatch(errorProcessingPayment(endCondition, secondParam, providerId));
            dispatch(sendEmailReport(getState().selectedRestaurant.restaurantId, endCondition, `FAILED-paymentProvider-${providerId}`));
            return resolve();
        }
        // Didn't match and too much time, reject!
        else {

            reject(new Error('Poll rejected ' + fn + ': ' + arguments));
        }
    };

    return new Promise(checkCondition);
};

const checkConditionsAccordingToProvider = (providerId, getState) => {

    let returnData = null;
    if (providerId === 3) {
        returnData = {
            successCondition: 'PAID',
            paymentId: getState().paymentProvider.mollieTransactionId,
            errOrigin: 'mollieCheckoutResponse'
        }
    } else if (providerId === 4) {
        returnData = {
            successCondition: 'APPROVED',
            paymentId: getState().paymentProvider.authipayData.orderId,
            errOrigin: 'authipayCheckoutResponse'
        }
    }

    return returnData;
};

export const saveAuthipayData = (providerData) => {
    return (dispatch) => {

        dispatch({ type: AUTHIPAY_DATA, payload: providerData });
    }
};

export const saveWorldPayData = (providerData) => {
    return (dispatch) => {
        dispatch({ type: WORLDPAY_DATA, payload: providerData });
    }
}

export const clearWorldPayData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_WORLDPAY_DATA });
    }
}

export const saveBamboraData = (providerData) => {
    return (dispatch) => {
        dispatch({ type: BAMBORA_DATA, payload: providerData })
    }
}

export const clearBamboraData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_BAMBORA_DATA })
    }
}

export const saveStripeHostedPaymentData = (providerData) => {
    return (dispatch) => {
        dispatch({ type: STRIPE_HOSTED_PAYMENT_DATA, payload: providerData })
    }
}

export const clearStripeHostedPaymentData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_STRIPE_HOSTED_PAYMENT_DATA })
    }
}

export const saveMonerisData = (providerData) => {
    return (dispatch) => {
        dispatch({ type: MONERIS_DATA, payload: providerData });
    }
}

export const clearMonerisData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_MONERIS_DATA });
    }
}

export const saveRyftData = (providerData) => {
    return (dispatch) => {
        dispatch({ type: RYFT_DATA, payload: providerData });
    }
}

export const clearRyftData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_RYFT_DATA });
    }
}

export const clickAppleGooglePay = () => {
    return (dispatch) => {

        dispatch({ type: CLICK_APPLE_GOOGLE_PAY });
    }
};

export const clearTbkData = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_TBK_DATA });
    }
}

export const sendTbkToken = (tbkTokenParam, dataForTbkRedirects, history, restaurantId) => {
    return (dispatch, getState) => {
        const url = `payment/confirmEnrollment?TBK_TOKEN=${tbkTokenParam}`;

        axios(getState).post(url)
        .then(res => {
            sendTbkTokenSuccess(res, dispatch, dataForTbkRedirects, history)
        })
        .catch(err => sendTbkTokenError(err, dispatch, dataForTbkRedirects, history, restaurantId));
    }
};

const sendTbkTokenSuccess = (res, dispatch, dataForTbkRedirects, history) => {
    dispatch({ type: TBK_USER_DATA, payload: res.data });
    
    if (dataForTbkRedirects) {
        tbkRedirects(dataForTbkRedirects, history);
    }
};

const sendTbkTokenError = (err, dispatch, dataForTbkRedirects, history, restaurantId) => {
    dispatch({ type: CONFIRM_ENROLLMENT_ERR_MSG, payload: err.response.data });
    if (dataForTbkRedirects) {
        tbkRedirects(dataForTbkRedirects, history);
    }
    sendEmailReport(restaurantId, err, 'Tbk Token Error');
}

const tbkRedirects = (dataForTbkRedirects, history) => {
        const { restaurantTypeId, selectedOrderTypeId, restaurantId, selectedThemeType, selectedThemePrimaryColor } = dataForTbkRedirects;

        let queryParams = `?restaurantId=${restaurantId}&theme=${selectedThemeType}`;

        if (selectedThemeType === 'CUSTOM') {
            let color = selectedThemePrimaryColor;
            if (selectedThemePrimaryColor.startsWith('#')) {
                color = color.slice(1);
            }
            queryParams += `&primaryColor=${color}`;
        }

        if (selectedOrderTypeId === IN_STORE_ID) {
            queryParams += `&typeId=${restaurantTypeId}`;
        }

        if (selectedOrderTypeId === IN_STORE_ID) {
            history.replace({pathname: `${queryParams}#/checkout`});
            history.go(0);
        } else {
            history.push(`/#/checkout`)
            history.go(0);
        }
}

export const clearConfirmEnrollmentErrMsg = () => {
    return (dispatch, getState) => {
        dispatch({ type: CONFIRM_ENROLLMENT_ERR_MSG, payload: null });
    }
}